/**
 * ==========================================================================
 * JHC Commerce Framework
 * Announcement Bar
 * --------------------------------------------------------------------------
 * - Auto-rotating slides
 * - Prev / next navigation
 * - Dismiss with sessionStorage memory
 * ==========================================================================
 */

(function () {
  'use strict';

  function initAnnouncement() {
    const bar = document.querySelector('.jhc-announcement');
    if (!bar) return;

    const track      = bar.querySelector('.jhc-announcement__track');
    const slides     = bar.querySelectorAll('.jhc-announcement__slide');
    const prevBtn    = bar.querySelector('.jhc-announcement__prev');
    const nextBtn    = bar.querySelector('.jhc-announcement__next');
    const dismissBtn = bar.querySelector('.jhc-announcement__dismiss');

    if (!track || !slides.length) return;

    const autoplay     = bar.dataset.autoplay === 'true';
    const speed        = parseInt(bar.dataset.speed, 10) * 1000 || 4000;
    const dismissible  = bar.dataset.dismissible === 'true';
    const storageKey   = 'jhc-announcement-dismissed-' + bar.id;

    let current  = 0;
    let timer    = null;
    const total  = slides.length;

    // -----------------------------------------------------------------------
    // DISMISSED STATE
    // -----------------------------------------------------------------------

    if (dismissible && sessionStorage.getItem(storageKey)) {
      bar.setAttribute('data-dismissed', '');
      return;
    }

    // -----------------------------------------------------------------------
    // SLIDE
    // -----------------------------------------------------------------------

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = `translateX(-${current * 100}%)`;

      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i !== current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    // -----------------------------------------------------------------------
    // AUTOPLAY
    // -----------------------------------------------------------------------

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      clearInterval(timer);
    }

    // Pause on hover
    bar.addEventListener('mouseenter', stopAutoplay);
    bar.addEventListener('mouseleave', startAutoplay);

    // -----------------------------------------------------------------------
    // CONTROLS
    // -----------------------------------------------------------------------

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        stopAutoplay();
        prev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoplay();
        next();
        startAutoplay();
      });
    }

    // -----------------------------------------------------------------------
    // DISMISS
    // -----------------------------------------------------------------------

    if (dismissBtn) {
      dismissBtn.addEventListener('click', () => {
        stopAutoplay();
        bar.setAttribute('data-dismissed', '');
        if (dismissible) {
          sessionStorage.setItem(storageKey, '1');
        }
      });
    }

    // -----------------------------------------------------------------------
    // TOUCH SWIPE
    // -----------------------------------------------------------------------

    let touchStartX = 0;

    bar.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    bar.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? next() : prev();
      }
    }, { passive: true });

    // -----------------------------------------------------------------------
    // REDUCED MOTION
    // -----------------------------------------------------------------------

    const prefersReduced = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReduced) return;

    // -----------------------------------------------------------------------
    // INIT
    // -----------------------------------------------------------------------

    goTo(0);
    startAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncement);
  } else {
    initAnnouncement();
  }

})();
